<template>
  <motlet-neo :options="motletOptions">
    <template v-slot:content="{ props }">
      <!-- eslint-disable-next-line prettier/prettier -->
      <line-chart
        :settings="settings"
        :motlet="props.motlet"
        :store-name="storeName"
        :active-increment="activeIncrement"
      />
    </template>
  </motlet-neo>
</template>

<script>
import { merge } from 'lodash';
// BEGIN::Added.by.KWShin.2024.03.06.
import bus from '@/utils/bus';
// FINISH::Added.by.KWShin.2024.03.06.
// BEGIN::Added.by.SHJ.2026.04.27.
import { api } from '@/api/common/instances';
// FINISH::Added.by.SHJ.2026.04.27.
import lineChartable from './lineChartable';

export default {
  mixins: [lineChartable],
  data() {
    return {
      motletOptions: {
        id: 'dv/abap/os/cpu',
        title: 'dv.title.cpu',
        monitor: { monitorCode: 'C_PCAP_OS_CPU', eventCode: 'ABAP_OS_CPU', points: 60 },
        settings: { chart: { use: true } },
        xAxisPoints: {
          use: true,
          divider: false,
          ready: false,
          value: 60,
          default: 60,
        },
      },
      // Realtime 데이터 가공을 위한 임시 버퍼들.
      socketData: [],
      socketFlag: [],
    };
  },
  watch: {
    sstmId: {
      handler() {
        // BEGIN::Modified.by.KWShin.2024.02.15.
        // OperatingSystem.vue에서는 systemId가 바뀌었을 때
        // activeIncrement가 true일 때만 WebSocket.connect()를 하고 있다.
        // 여기서도 activeIncrement를 체크하는 게 맞다.
        // this.sendMessage();
        /*
         * Modified.by.KWShin.2024.03.07.
         * 부모가 xPoints 값을 설정해준 뒤에만 데이터 구독을 시작한다.
         * 일반적으로 최초의 systemId 변경 이벤트는
         * 부모가 xPoints 값을 DB에서 읽어오는 것이 완료되기 전에 발생한다.
         */
        if (this.activeIncrement && this.motletOptions.xAxisPoints.ready) this.sendMessage();
        // FINISH::Modified.by.KWShin.2024.02.15.
      },
    },
    activeIncrement: {
      immediate: true,
      handler(value) {
        /*
         * Modified.by.KWShin.2024.03.07.
         * 부모가 xPoints 값을 설정해준 뒤에만 데이터 구독을 시작한다.
         */
        if (value && this.motletOptions.xAxisPoints.ready) this.sendMessage();
      },
    },
  },
  methods: {
    wsBufferedDataHandler(key, responses) {
      /*
       * responses의 자료구조
       * [?]
       *  ? ->{ ctime, empty, data: [?]}
       *    ? -> { stime, sysTotal, usrTotal }
       */
      const [response] = responses;
      // BEGIN::Modified.by.KWShin.2024.03.07.
      // 데이터 구독 시 버퍼 사이즈를 지정하므로 원하는 데이터 개수가 내려오므로
      // 따로 데이터를 자를 필요 없다.
      // const bound = response.length < this.monitor.points ? response.length : this.monitor.points;
      // const data = response.slice(response.length - bound).map(item => {
      const data = response.map(item => {
        // FINISH::Modified.by.KWShin.2024.03.07.
        const {
          data: [data],
        } = item;
        return this.dataHandler({ ctime: item.ctime, ...data });
      });
      /*
       * 바로 위에서 구한 data의 자료구조
       * [?]
       *  ? -> { ctime, stime, usedRate }
       */
      this.socketData.push({
        id: key.instId,
        data,
      });
      if (this.socketData.length == this.descendants.length) {
        this.data = merge([], this.socketData);
        this.socketData = [];
        // BEGIN::Added.by.KWShin.2024.03.06.
        // Buffered Data를 새로 받았으므로 후속 처리를 위해 초기화해준다.
        this.socketFlag = this.descendants.map(des => {
          return { id: des.id, arrived: false };
        });
        // FINISH::Added.by.KWShin.2024.03.06.
        this.prepend(['usedRate']);
        /*
         * Added.by.KWShin.2024.03.07.
         * 차트에서 MarkLine이 그려질 때 'change:timestamp' 이벤트가 발생되면,
         * 부모 컴포넌트에서 이 이벤트를 받아 그리드와 다이어그램에 timestamp 변경을 통지하는데,
         * markLine은 화면이 시작된 이후 최초의 수집주기가 지나야 그려져서
         * 화면이 진입한 후 최초의 수집주기가 지나기 전까지는 그리드에 데이터 표시도 안되고
         * 다이어그램이 그려지지도 않는다.
         * 따라서, 이 시점에서 'change:timestamp' 이벤트를 발생시켜 주어서 화면 진입 후 즉각적으로
         * 그리드와 다이어그램이 정상적으로 표시될 수 있도록 한다.
         */
        // 데이터 수집이 안되고 있는 시스템이 있을 수 있으므로 this.data의 유무를 체크해야 한다.
        if (this.data && this.data.length > 0) {
          bus.$emit(`change:timestamp-${this.storeName}`, {
            eventCode: this.motletOptions.monitor.eventCode,
            timestamp: this.data[this.data.length - 1].ctime,
          });
        }
        // BEGIN::Added.by.SHJ.2026.04.27.
        // WS 버퍼가 차트 X축 개수(monitor.points)만큼 채우지 못한 경우 앞쪽 빈 구간을 DB에서 보충한다.
        this.backfillFromDb();
        // FINISH::Added.by.SHJ.2026.04.27.
      }
    },
    wsDataHandler(key, response, ctime) {
      const {
        data: [data],
      } = { data: response };
      const socketData = this.dataHandler({ ctime: parseInt(ctime), ...data });
      const target = this.data.find(d => d.id == key.instId);
      if (target) {
        target.data.push(socketData);
        // this.prepop();
        target.data.splice(0, 1);
      }
      /*
       * Added.by.KWShin.2024.03.07.
       * Flag를 뒤져보니 방금 도착한 데이터의 인스턴스가 이미 데이터를 받은 상태란다.
       * 그러면, 동일 인스턴스의 새로운 데이터가 도착한 거다.
       * 그때까지 데이터가 도착 안한 인스턴스가 존재하면,
       * 데이터가 오지 못할 사정(BeeBird down, Network Problem, etc.)이 있는 것으로 보고
       * (3초 간격이기 때문에 특별한 사정이 없는 한 모든 인스턴스의 데이터가 한 차례씩 올 것이기 때문에)
       * 아직 데이터가 도착하지 않은 인스턴스 데이터에 비어있는 데이터를 하나 추가해준다.
       */
      const inst = this.socketFlag.find(i => i.id == key.instId);
      if (inst.arrived) {
        this.socketFlag.forEach(i => {
          if (i.arrived == false) {
            const target = this.data.find(d => d.id == i.id);
            if (target) {
              target.data.push({ ctime: parseInt(ctime), stime: parseInt(ctime), usedRate: undefined });
              // this.prepop();
              target.data.splice(0, 1);
            }
          }
          if (i.id == key.instId) i.arrived = true;
          else i.arrived = false;
        });
      } else {
        inst.arrived = true;
      }
    },
    /**
     * Commented.by.KWShin.2024.02.15.
     * this.monitor? 요넘의 정체는?
     * 이는 lineChartable.js에서 mixins된 motletable.js에 compute()로 선언된 변수인데,
     * 이 값은 template에 마크된 <motlet> 컴포넌트에 props 'options'로 넘어간 값을
     * Motlet 컴포넌트 생성 시에 store에 넣어준 거다.
     * 결국은 this.motletOptions 내의 monitor라는 속성값이다.
     */
    dataHandler(data) {
      const ctime = parseInt(data.ctime);
      return {
        ctime: ctime - (ctime % this.monitor.cycle), // db 데이터 간격 기준으로 실시간 데이터를 근사값으로 보정,
        stime: parseInt(data.stime),
        usedRate: Math.ceil(parseFloat(data.usrTotal) + parseFloat(data.sysTotal)),
      };
    },
    // BEGIN::Added.by.SHJ.2026.04.27.
    /**
     * WS 버퍼가 monitor.points 만큼 채워지지 않았을 때 DB에서 부족한 앞 구간을 조회해
     * 이미 비어있는 슬롯(usedRate===undefined)에만 값을 주입한다. 실제 WS 데이터는 덮어쓰지 않는다.
     */
    async backfillFromDb() {
      if (!this.data || this.data.length === 0) return;
      const firstInst = this.data[0].data;
      if (!firstInst || firstInst.length === 0) return;
      const realPoints = firstInst.filter(d => d.usedRate !== undefined && d.usedRate !== '');
      if (realPoints.length === firstInst.length) return;
      const beginYmdhms = firstInst[0].ctime;
      const endYmdhms = realPoints.length > 0 ? realPoints[0].ctime - this.monitor.cycle : firstInst[firstInst.length - 1].ctime;
      if (endYmdhms < beginYmdhms) return;
      const params = {
        beginYmdhms,
        endYmdhms,
        sstmId: this.sstmId,
        motletCode: this.monitor.monitorCode,
        ...this.dataParam,
      };
      try {
        const { data: results } = await api.get('/motlet-data/chart', { params });
        if (!results || results.length === 0) return;
        results.forEach(result => {
          const inst = this.data.find(d => d.id === result.key.instId);
          if (!inst) return;
          result.data.forEach(db => {
            const dbCtime = parseInt(db.ctime);
            const slot = inst.data.find(p => p.ctime === dbCtime);
            if (slot && (slot.usedRate === undefined || slot.usedRate === '')) {
              slot.usedRate = parseInt(db.usedRate);
              if (db.stime) slot.stime = parseInt(db.stime);
            }
          });
        });
      } catch (e) {
        // DB 조회 실패 시 차트는 WS 실시간 수신으로 점진적으로 채워지므로 무시한다.
        console.warn('[PcapCpu] backfillFromDb failed', e);
      }
    },
    // FINISH::Added.by.SHJ.2026.04.27.
    /**
     * Added.by.KWShin.20204.03.07.
     * 부모가 X축 길이 설정값을 가져온 뒤 호출해준다.
     * Motlet 메뉴에서 X축 길이 설정이 변경되었을 때에도
     * 편의상 (로직이 동일하므로) 자기 스스로 호출한다.
     */
    xPointsChanged(xPoints) {
      this.motletOptions.xAxisPoints.ready = true;
      this.motletOptions.xAxisPoints.value = xPoints;
      this.motletOptions.monitor.points = xPoints;
      // setXAxisPoints()는 lineChartable.js에 mixins된 motletable.js에 선언된 메소드로 store를 변경시켜준다.
      this.setXAxisPoints(xPoints);
      this.setMonitor(this.motletOptions.monitor);
      /*
       * DB 설정에서 읽어온 xPoints 값을 부모가 전달해주기 전까지는 데이터 구독이 방지되어 있는 상태이므로,
       * 부모에게서 통지가 왔을 때 데이터 구독을 시작한다.
       */
      if (this.activeIncrement) this.sendMessage();
    },
    /**
     * Commented.by.KWShin.2024.02.15.
     * descendants는 lineChartable.js에 compute로 선언되어 있고,
     * props로 받은 storeName으로 Vuex store에 저장되어 있는 (부모가 넣어준)
     * descendants 정보를 가져온다.
     */
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.descendants.map(descendant => ({
          key: { name: 'pcapOsCpu', sstmId: descendant.systemId, instId: descendant.id },
          fields: ['stime', 'usrTotal', 'sysTotal'],
          // BEGIN::Added.by.KWShin.2024.03.06.
          bufferSize: this.monitor.points,
          // FINISH::Added.by.KWShin.2024.03.06.
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        })),
      });
    },
  },
  created() {
    /*
      Commmented.by.KWShin.2024.03.06.
      Motlet에 포함된 Settings.vue에서 xAxisPoints에 변동이 생기면 Bus에서 신호가 온다.
      xAxisPoints에 변화가 있으면 차트의 X축의 범위를 변경한다.
    */
    bus.$on(`update:xAxisPoints-${this.motletOptions.id}`, xAxisPoints => {
      /*
       * 실시간인 상태에서 X축 표시범위를 변경하게 되면 차트를 동기화하기가 너무 어렵다.
       * 설정이 변하는 시점에서는 실시간 상태를 꺼준다.
       */
      bus.$emit(`update:activeIncrement`, false);
      this.xPointsChanged(xAxisPoints);
    });
  },
  destroyed() {
    // BEGIN::Added.by.KWShin.2024.03.06.
    bus.$off(`update:xAxisPoints-${this.motletOptions.id}`);
    // FINISH::Added.by.KWShin.2024.03.06.
  },
};
</script>
